import { ALL_FEATURES_AVAILABLE, SubscriptionPlans } from '../../../../../../user/user/user.model';
import { MapModalData } from '../../../../../../user/map-redirect-modal/map-redirect-modal.component';
import { ROUTER_NAVIGATE } from '../../../../../../user/map-redirect-modal/map-redirect-modal-text';

export function generateInaccessibleModalData(
  featureDisplayName: string,
  isUnauthorized: boolean,
  featureConst: string,
  isTrial: boolean
): MapModalData {
  // For unauthorized users
  if (isUnauthorized) {
    return {
      headerText: `Unlock This Feature with a Free Trial`,
      mainText: `You're using a guest version with limited access.`,
      additionalText:
        'Start your free trial to explore it now — no credit card needed.',
      buttonText: 'Start Free Trial',
      URLtoGo: '/sign-up',
      actionType: ROUTER_NAVIGATE,
      hasBackdrop: true,
      gaEventOnButtonClick: 'start_free_trial_click',
    };
  }

  // For subscribed users determine which plans offer the feature
  const userFacingPlans: SubscriptionPlans[] = [
    SubscriptionPlans.BASIC,
    SubscriptionPlans.PRO,
    SubscriptionPlans.PLUS,
  ];

  // the one that unlock the feature
  const unlockingPlans = userFacingPlans.filter((planKey) => {
    const plan = SubscriptionPlans.description[planKey];
    return (
      plan.accessibleFeatures == ALL_FEATURES_AVAILABLE || ( Array.isArray(plan.accessibleFeatures) && plan.accessibleFeatures.includes(featureConst))
    );
  });

  const baseModal: Omit<MapModalData, 'mainText'> = {
    headerText: `Unlock ${featureDisplayName}`,
    buttonText: 'Get started',
    URLtoGo: '/user/subscription',
    actionType: ROUTER_NAVIGATE,
    hasBackdrop: true,
    gaEventOnButtonClick: 'get_started_locked_param',
  };

  // Generate message based on which plans unlock the feature
  // if (
  //   unlockingPlans.length === 2 &&
  //   unlockingPlans.includes(SubscriptionPlans.KNOW_YOUR_COUNTRY) &&
  //   unlockingPlans.includes(SubscriptionPlans.ENTERPRISE)
  // ) {
  //   // KYC and ENTERPRISE only
  //   return {
  //     ...baseModal,
  //     mainText: `${featureDisplayName} is a part of Know Your Country and Location Intelligence plans.`,
  //     additionalText: `Unlock it with a subscription — starting at just $4.95/month.`,
  //   };
  // }

  // if (
  //   unlockingPlans.length === 1 &&
  //   unlockingPlans.includes(SubscriptionPlans.KNOW_YOUR_COUNTRY)
  // ) {
  //   // KYC only
  //   return {
  //     ...baseModal,
  //     mainText: `${featureDisplayName} is a part of Know Your Country plan.`,
  //     additionalText: `Get full access for just $4.95/month to keep exploring without limits.`,
  //   };
  // }

  // if (
  //   unlockingPlans.length === 1 &&
  //   unlockingPlans.includes(SubscriptionPlans.ENTERPRISE)
  // ) {
  //   // ENTERPRISE only
  //   return {
  //     ...baseModal,
  //     mainText: `${featureDisplayName} is a part of Location Intelligence plan.`,
  //     additionalText: `Upgrade to unlock advanced data insights and keep exploring without limits.`,
  //   };
  // }

  // const nonRealtorEnterprisePlans = unlockingPlans.filter((plan) => {
  //   return (
  //     plan !== SubscriptionPlans.ENTERPRISE &&
  //     plan !== SubscriptionPlans.REALTOR
  //   );
  // });
  //
  console.log(unlockingPlans);
  console.log(userFacingPlans);
  if ( unlockingPlans.length !== userFacingPlans.length ) {
    const excludedPlans = userFacingPlans
      .filter((p) => !unlockingPlans.includes(p))
      .map((p) => {
        // Use the specific plan names
        // if (p === SubscriptionPlans.REALTOR) return 'Realtor’s Special';
        // if (p === SubscriptionPlans.ENTERPRISE) return 'Location Intelligence';
        return SubscriptionPlans.description[p].planName;
      })
      .join(' or ');

    return {
      // All but ENTERPRISE and REALTOR
      ...baseModal,
      mainText: `${featureDisplayName} is available in all packages except ${excludedPlans}.`,
      additionalText: `To access it, upgrade to any other subscription plan.`,
    };
  }

  // Default fallback message for all subscriptions
  return {
    ...baseModal,
    mainText: `${featureDisplayName} is available with any package.`,
    additionalText: `Get full access for just $10.`,
  };
}
